export const HEALTH_CHECK_URL = 'healthcheck';
